<sb-dialog-header />
<sb-dialog-content>
  <div class="flex flex-col items-center gap-md px-lg pb-md">
    <sb-icon-badge icon="gift-regular" color="brand" size="2xlarge" appearance="filled" />
    <h2 class="mb-lg text-3xl font-extrabold">{{ 'Earn up to €250' | translate }}</h2>

    <p class="mb-0 text-center text-base font-medium text-default">
      {{
        'Share Shiftbase with another business and help them solve their planning chaos. They get 50% off for their first 3 months. You earn 30% of their Shiftbase subscription costs (up to €250 per referral).'
          | translate
      }}
    </p>

    <sb-checkbox [(ngModel)]="optIn" [truncateLabel]="false">
      <span class="text-sm text-default">
        {{
          'I agree to join the Shiftbase Referral Program operated by [referralPartner]'
            | translate: { referralPartner: 'Cello' }
        }}.{{ 'See' | translate }}
        <a href="https://cello.so/terms-of-service/" target="_blank" class="font-bold underline">
          {{ 'Terms of Service' | translate }}
        </a>
        {{ 'and' | translate }}
        <a href="https://cello.so/privacy-policy-cello-platform/" target="_blank" class="font-bold underline">
          {{ 'Privacy Policy' | translate }}</a
        >.
      </span>
    </sb-checkbox>
  </div>
</sb-dialog-content>
<sb-dialog-footer class="justify-center">
  <button sb-button [sbLadda]="isSaving()" color="primary" (click)="submit()" [disabled]="!optIn">
    {{ 'Invite & Earn' | translate }}
  </button>
</sb-dialog-footer>
